import classNames from 'classnames';
import Badge, {
  Props as BadgeProps
} from '../../Atoms/Badge';
import Button, {
  Props as ButtonProps
} from '../../Atoms/Button';
import Icon from '../../Atoms/Icon';
import Tag, { Props as TagProps } from '../../Atoms/Tag';
import Text from '../../Atoms/Text';
import Title from '../../Atoms/Title';

import styles from './CardVacancyExt.module.css';

type Props = {
  link: string;
  linkDirectApply?: string;
  title: string | JSX.Element;
  description?: string | JSX.Element;
  badges?: BadgeProps[];
  tags?: TagProps[];
  buttons?: ButtonProps[];
};

function CardVacancyExt({
  link,
  linkDirectApply,
  title,
  description,
  badges,
  tags
}: Props) {
  return (
    <div className="@container">
      <div
        className={classNames([
          styles.card,
          'group relative block rounded-xl text-sl-blue shadow-light transition-colors duration-300 hover:text-white'
        ])}
      >
        <div className="relative z-[5] rounded-xl border-2 border-sl-blue-dark border-opacity-10 p-4 group-hover:border-opacity-0 @lg:p-8">
          <div className="mb-2 flex items-start justify-between">
            <Title
              as="h3"
              weight={500}
              color="inherit"
              font="circular"
              className="mr-2"
            >
              <span className="block text-lg !leading-tight @sm:text-xl @lg:text-2xl">
                {title}
              </span>
            </Title>
            {badges && (
              <div className="flex gap-x-1">
                {badges.map((badge) => (
                  <Badge
                    {...badge}
                    key={badges.indexOf(badge)}
                    className="whitespace-nowrap"
                  />
                ))}
              </div>
            )}
          </div>
          {description && (
            <Text
              as="div"
              color="inherit"
              className="mb-4 line-clamp-2"
            >
              <p className="block text-sm !leading-tight @lg:text-base">
                {description}
              </p>
            </Text>
          )}
          <footer className="flex flex-wrap items-center justify-between gap-4 pr-8 pt-2 @xl:pr-0">
            <ul className="flex w-full flex-1 flex-wrap gap-x-4 gap-y-1 font-camphor text-xs font-medium @lg:text-sm @2xl:text-base">
              {tags?.map((tag) => (
                <li
                  key={tags.indexOf(tag)}
                  className="inline-flex"
                >
                  <Tag
                    {...tag}
                    className="text-sl-gray transition-colors duration-300 group-hover:text-white"
                    iconClass="group-hover:text-sl-yellow text-[1.1em] shrink-0"
                  />
                </li>
              ))}
            </ul>
            <div className="relative z-[5] hidden justify-end gap-x-5 gap-y-3 @xl:flex">
              <Button
                as="a"
                href={link}
                color="gray-outline"
                className="!duration-[0s] hover:!bg-transparent group-hover:!border-white group-hover:!border-opacity-25 group-hover:!text-white"
                text="Meer info"
              />
              {linkDirectApply && (
                <Button
                  text="Direct solliciteren"
                  as="a"
                  color="primary"
                  href={linkDirectApply}
                />
              )}
            </div>
            <a
              href={link}
              className="absolute inset-0 z-[1]"
            >
              <span className="sr-only">{title}</span>
            </a>
            <span
              className={classNames([
                styles.pseudoBtn,
                'absolute -bottom-[2px] -right-[2px] flex h-12 w-12 items-center justify-center rounded-tl-[48px] rounded-br-lg pt-2  pl-2 text-sm text-white @xl:hidden'
              ])}
            >
              <Icon icon="arrow-right" />
            </span>
          </footer>
        </div>
      </div>
    </div>
  );
}

export default CardVacancyExt;
